import { render, staticRenderFns } from "./CountButtons.vue?vue&type=template&id=14e1970c&scoped=true&"
import script from "./CountButtons.vue?vue&type=script&lang=js&"
export * from "./CountButtons.vue?vue&type=script&lang=js&"
import style0 from "./CountButtons.vue?vue&type=style&index=0&id=14e1970c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e1970c",
  null
  
)

export default component.exports